import { i18n } from '@/plugins/i18n'

export const IvrShopType = {
    IVR:    1,
    VIP:  2,

};

export const IvrTypeStr = {
    IVR:    i18n.t('ivr.type.ivr'),
    VIP:  i18n.t('ivr.type.vip'),


    get(type) {
        let type_str = null;

        Object.keys(IvrShopType).forEach(item => {
            if(IvrShopType[item] === type) {
                type_str = IvrTypeStr[item];
            }
        });

        return type_str;
    }
};

